module.exports = __webpack_public_path__ + "static/media/recipie.7590cc4b.png";